import { ReactComponent as EditAdminSvg } from "../../assets/images/svgs/editAdmin.svg";

const EditAdminIcon = ({ className = "", ...props }) => {
  return (
    <EditAdminSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default EditAdminIcon;
